import React from 'react';
import {
  AcUnit, Air, Blinds, CleaningServices, ElectricalServices,
  Lightbulb, LocalFireDepartment, Lock, PowerSettingsNew, Security, Tv,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { NodeType } from '../types';
import { Strings } from '../i18n/strings';

export interface NodeTypeConfig {
  type: NodeType;
  Icon: React.ComponentType<SvgIconProps>;
  labelKey: keyof Strings;
  // IR accessories: fire-and-forget, no readable on/off state. The card shows a
  // transient "command sent" confirmation instead of a (meaningless) On/Off status.
  stateless?: boolean;
}

export const NODE_TYPES: NodeTypeConfig[] = [
  { type: 'generic',         Icon: PowerSettingsNew,   labelKey: 'nodeTypeGeneric' },
  { type: 'thief_alert',     Icon: Security,           labelKey: 'nodeTypeThiefAlert' },
  { type: 'door_lock',       Icon: Lock,               labelKey: 'nodeTypeDoorLock' },
  { type: 'light',           Icon: Lightbulb,          labelKey: 'nodeTypeLight' },
  { type: 'air_conditioner', Icon: AcUnit,             labelKey: 'nodeTypeAirConditioner', stateless: true },
  { type: 'boiler',          Icon: LocalFireDepartment, labelKey: 'nodeTypeBoiler' },
  { type: 'shutter',         Icon: Blinds,             labelKey: 'nodeTypeShutter' },
  { type: 'fan',             Icon: Air,                labelKey: 'nodeTypeFan', stateless: true },
  { type: 'smart_plug',      Icon: ElectricalServices, labelKey: 'nodeTypeSmartPlug' },
  { type: 'vacuum',          Icon: CleaningServices,   labelKey: 'nodeTypeVacuum' },
  { type: 'tv',              Icon: Tv,                 labelKey: 'nodeTypeTv', stateless: true },
];

export const getNodeTypeConfig = (type?: NodeType): NodeTypeConfig =>
  NODE_TYPES.find(c => c.type === type) ?? NODE_TYPES[0];
